module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeft--dark-d9f102ae9bea3af236389971b29693cf.png";